/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnitEnum } from './UnitEnum';
import {
    UnitEnumFromJSON,
    UnitEnumFromJSONTyped,
    UnitEnumToJSON,
    UnitEnumToJSONTyped,
} from './UnitEnum';

/**
 * Durée exprimée dans une unité du référentiel.
 * @export
 * @interface DureeDto
 */
export interface DureeDto {
    /**
     * 
     * @type {string}
     * @memberof DureeDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof DureeDto
     */
    value?: number;
    /**
     * 
     * @type {UnitEnum}
     * @memberof DureeDto
     */
    unite?: UnitEnum;
}



/**
 * Check if a given object implements the DureeDto interface.
 */
export function instanceOfDureeDto(value: object): value is DureeDto {
    return true;
}

export function DureeDtoFromJSON(json: any): DureeDto {
    return DureeDtoFromJSONTyped(json, false);
}

export function DureeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DureeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'value': json['value'] == null ? undefined : json['value'],
        'unite': json['unite'] == null ? undefined : UnitEnumFromJSON(json['unite']),
    };
}

export function DureeDtoToJSON(json: any): DureeDto {
    return DureeDtoToJSONTyped(json, false);
}

export function DureeDtoToJSONTyped(value?: DureeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'value': value['value'],
        'unite': UnitEnumToJSON(value['unite']),
    };
}

